<template>
  <div class="table__row" :class="{'table__row--dec': !info.active}">
    <div class="table__cell">
      <toggle-button color="#0290FC" :width="40" :sync="true" v-model="info.active" />
    </div>
    <div class="table__cell">
      <div class="table__cell-title">{{ info.businessName }}</div>
    </div>
    <div class="table__cell">
      <div class="table__cell-title">{{ info.contactName }}</div>
    </div>
    <div class="table__cell">
      <div class="table__cell-title">{{ info.address }}</div>
    </div>
    <div class="table__cell">
      <div class="table__cell-title">{{ info.phone }}</div>
      <div class="table__cell-subtitle">{{ info.email }}</div>
    </div>
    <div class="table__cell table__cell--coordinate">
      <div class="table__cell-subtitle">Long: <span>{{ info.long }}</span></div>
      <div class="table__cell-subtitle">Lat: <span>{{ info.lat }}</span></div>
    </div>
  </div>
</template>

<script>
import {ToggleButton} from 'vue-js-toggle-button'

export default {
  name: 'Customer',
  components: {
    ToggleButton
  },
  props: {
    info: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'style';
</style>
